import { Zap } from "lucide-react";
import { useBranding } from "@/hooks/useBranding";

/** Header logo: custom uploaded icon when set by admin, default bolt otherwise. */
export function AppName({ className = "" }) {
  const { short_name } = useBranding();
  return <span className={className} data-testid="app-name">{short_name}</span>;
}

export default function AppLogo({ size = "md", className = "" }) {
  const { has_custom, icon_192 } = useBranding();
  const box = size === "lg" ? "w-11 h-11 rounded-2xl" : "w-9 h-9 rounded-xl";
  const icon = size === "lg" ? "w-6 h-6" : "w-5 h-5";
  if (has_custom && icon_192) {
    return <img src={icon_192} alt="FUTURO PDV" className={`${box} object-cover ${className}`} data-testid="app-logo-custom" />;
  }
  return (
    <div className={`${box} bg-primary flex items-center justify-center ${className}`} data-testid="app-logo-default">
      <Zap className={`${icon} text-primary-foreground`} />
    </div>
  );
}
